globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.Statistics = (function() {
  function Statistics() {
    this.$body = $('body');

    this.init();
  }

  Statistics.prototype = {
    init: function() {
      this.initEvents();
    },
    initEvents: function(){
      var me                   = this,
          $statisticsContainer = $('#highcharts-container'),
          ajaxUrl              = $statisticsContainer.data('ajax-url'),
          errorMsg             = 'Erreur de chargement des statistiques',
          queryString          = window.location.search;
      appCustomerSpace.Loader().start({ $container: $('.content-wrapper') });

      if(ajaxUrl) {
        $.get(ajaxUrl + queryString, function(data) {
            if(data.response) {
              appCustomerSpace.Loader().stop({ $container: $('.content-wrapper') }, function() {
                  $statisticsContainer.append(data.html);
                  me.dateRangePicker(data);
                  me.displayCharts();
                  appCustomerSpace.LimitlessPlugins.initPlugins();
              });
            } else {
              alert(errorMsg);
            }
        }).fail(function() {
          alert(errorMsg);
        });
      } else {
        appCustomerSpace.Loader().stop({ $container: $('.content-wrapper') });
      };
    },
    displayCharts: function(){
      var me = this;
      Highcharts.setOptions({
          global: {
              useUTC: false
          },
          lang: appCustomerSpace.Modules.Charts.lang.t('highcharts')
      });

      $('.chart').each(function() {
          me.initHighcharts($(this));
      });
    },

    initHighcharts: function($container) {
      var $chart    = $container;
      var options   = $chart.data('highcharts-options');

      $.fn.highcharts.apply($chart, [options]);
    },

    dateRangePicker: function(data) {
      var picker = new DateRangePicker($('#range-picker').show(), data, {
          ranges: this._ranges(data["min_date"], data["max_date"])
          }, function(start, end) {
              var $form = $('form.form-date-range-filter');
              $form.find('.start-date-input').val(start.format('YYYY-MM-DD'));
              $form.find('.end-date-input').val(end.format('YYYY-MM-DD'));
              $form.trigger('submit');
          });
    },

    _ranges: function(minDate, maxDate) {
      var me     = this;
      var ranges = {};

      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.all')] = [moment(new Date(minDate)), moment(new Date(maxDate))]
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.thisWeek')] = [moment().startOf('isoWeek'), moment()];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastWeek')] = [moment().startOf('isoWeek').subtract(1, 'week'), moment().subtract(1, 'week').endOf('isoWeek')];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.twoWeeksAgo')] = [moment().startOf('isoWeek').subtract(2, 'week'), moment().subtract(2, 'week').endOf('isoWeek')];

      $.each([0, 1, 2, 3, 4], function(value) {
          var month = utils.capitalize(moment().subtract(value, 'month').format('MMMM YYYY'));
          ranges[month] = [moment().subtract(value, 'month').startOf('month'), (value == 0 ? moment() : moment().subtract(value, 'month').endOf('month'))];
      });

      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastSemester')] = [moment().subtract(6, 'months').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.beforeLastSemester')] = [moment().subtract(1, 'year').startOf('month'), moment().subtract(7, 'months').endOf('month')];

      return ranges;
    }
  }

  return Statistics;
})();
